import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store/store';

const API_HOST = process.env.REACT_APP_API_HOST;

export interface Payment {
  _id?: string;
  name?: string;
  description?: string;
  // Додайте інші поля платежу
  [key: string]: any;
}

export interface PaymentCreateRequest {
  name: string;
  description?: string;
  // Додайте інші поля для створення
  [key: string]: any;
}

export interface PaymentUpdateRequest {
  name?: string;
  description?: string;
  // Додайте інші поля для оновлення
  [key: string]: any;
}

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_HOST,
    credentials: 'include',
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info?.api_token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Payment'],
  endpoints: (build) => ({
    getPayments: build.query<{ data: Payment[]; total: number }, { page?: number; limit?: number; sortBy?: string; sortOrder?: string }>({
      query: (params) => {
        const query = new URLSearchParams();
        if (params.page) query.append('page', params.page.toString());
        if (params.limit) query.append('limit', params.limit.toString());
        if (params.sortBy) query.append('sortBy', params.sortBy);
        if (params.sortOrder) query.append('sortOrder', params.sortOrder);
        
        return {
          url: `payment/list?${query.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['Payment'],
    }),
    
    getPaymentById: build.query<Payment, string>({
      query: (id) => ({
        url: `payment/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Payment', id }],
    }),
    
    createPayment: build.mutation<Payment, PaymentCreateRequest>({
      query: (data) => ({
        url: 'payment/create',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Payment'],
    }),
    
    updatePayment: build.mutation<Payment, { id: string; data: PaymentUpdateRequest }>({
      query: ({ id, data }) => ({
        url: `payment/${id}/update`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Payment', id }, 'Payment'],
    }),
    
    deletePayment: build.mutation<void, string>({
      query: (id) => ({
        url: `management/api-key/remove/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Payment'],
    }),
  }),
});

export const {
  useGetPaymentsQuery,
  useGetPaymentByIdQuery,
  useCreatePaymentMutation,
  useUpdatePaymentMutation,
  useDeletePaymentMutation,
} = paymentApi; 